(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lk-curated-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lk-product-rail')) {
    class LKProductRail extends HTMLElement {
      scroll(direction) {
        const firstCard = this.track.querySelector(':scope > .lk-products__card');
        const cardWidth = firstCard?.getBoundingClientRect().width || this.track.clientWidth * 0.8;
        const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;

        this.track.scrollBy({
          left: direction * (cardWidth + gap),
          behavior: this.prefersReducedMotion.matches ? 'auto' : 'smooth',
        });
      }

      connectedCallback() {
        this.track = this.querySelector('[data-lk-product-track]');
        this.previousButton = this.querySelector('[data-lk-product-prev]');
        this.nextButton = this.querySelector('[data-lk-product-next]');

        if (!this.track || (!this.previousButton && !this.nextButton)) return;

        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.handleScroll = this.updateNavigation.bind(this);
        this.handlePrevious = () => this.scroll(-1);
        this.handleNext = () => this.scroll(1);

        this.previousButton?.addEventListener('click', this.handlePrevious);
        this.nextButton?.addEventListener('click', this.handleNext);
        this.track.addEventListener('scroll', this.handleScroll, { passive: true });

        this.resizeObserver = new ResizeObserver(this.handleScroll);
        this.resizeObserver.observe(this.track);
        requestAnimationFrame(this.handleScroll);
      }

      disconnectedCallback() {
        this.previousButton?.removeEventListener('click', this.handlePrevious);
        this.nextButton?.removeEventListener('click', this.handleNext);
        this.track?.removeEventListener('scroll', this.handleScroll);
        this.resizeObserver?.disconnect();
      }

      updateNavigation() {
        const maximumScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const position = Math.abs(this.track.scrollLeft);
        const tolerance = 2;

        if (this.previousButton) this.previousButton.disabled = position <= tolerance;
        if (this.nextButton) this.nextButton.disabled = position >= maximumScroll - tolerance;
      }
    }

    customElements.define('lk-product-rail', LKProductRail);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lk-kloset-index"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lk-kloset-index')) {
    class LKKlosetIndex extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.tabs = Array.from(this.querySelectorAll('[data-index-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-index-panel]'));
        this.panelsContainer = this.querySelector('[data-index-panels]');

        if (!this.tabs.length || this.tabs.length !== this.panels.length || !this.panelsContainer) return;

        this.initialized = true;
        this.activeIndex = Math.max(
          0,
          this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true')
        );
        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobilePointer = window.matchMedia('(max-width: 749px) and (pointer: coarse)');
        this.touchStart = null;

        this.tabListeners = this.tabs.map((tab, index) => {
          const handleClick = () => this.activate(index, { scrollTab: true });
          const handleKeydown = (event) => this.handleTabKeydown(event, index);
          tab.addEventListener('click', handleClick);
          tab.addEventListener('keydown', handleKeydown);
          return { tab, handleClick, handleKeydown };
        });

        this.handleTouchStart = (event) => {
          if (!this.mobilePointer.matches || event.touches.length !== 1) {
            this.touchStart = null;
            return;
          }

          this.touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
        };

        this.handleTouchEnd = (event) => {
          if (!this.touchStart || !this.mobilePointer.matches || event.changedTouches.length !== 1) {
            this.touchStart = null;
            return;
          }

          const deltaX = event.changedTouches[0].clientX - this.touchStart.x;
          const deltaY = event.changedTouches[0].clientY - this.touchStart.y;
          this.touchStart = null;

          if (Math.abs(deltaX) < 44 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.25) return;

          const direction = deltaX < 0 ? 1 : -1;
          const isRtl = document.documentElement.dir === 'rtl';
          this.activate(this.activeIndex + (isRtl ? direction * -1 : direction), { scrollTab: true });
        };

        this.handleTouchCancel = () => {
          this.touchStart = null;
        };

        this.handleBlockSelect = (event) => {
          if (!this.isConnected || !this.contains(event.target)) return;

          const selectedIndex = this.tabs.findIndex((tab) => tab.dataset.blockId === event.detail?.blockId);
          if (selectedIndex >= 0) this.activate(selectedIndex, { scrollTab: true });
        };

        this.panelsContainer.addEventListener('touchstart', this.handleTouchStart, { passive: true });
        this.panelsContainer.addEventListener('touchend', this.handleTouchEnd, { passive: true });
        this.panelsContainer.addEventListener('touchcancel', this.handleTouchCancel, { passive: true });
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
      }

      disconnectedCallback() {
        if (!this.initialized) return;

        this.tabListeners?.forEach(({ tab, handleClick, handleKeydown }) => {
          tab.removeEventListener('click', handleClick);
          tab.removeEventListener('keydown', handleKeydown);
        });

        this.panelsContainer?.removeEventListener('touchstart', this.handleTouchStart);
        this.panelsContainer?.removeEventListener('touchend', this.handleTouchEnd);
        this.panelsContainer?.removeEventListener('touchcancel', this.handleTouchCancel);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);

        this.touchStart = null;
        this.initialized = false;
      }

      handleTabKeydown(event, index) {
        let nextIndex;
        const isRtl = document.documentElement.dir === 'rtl';

        if (event.key === 'ArrowRight') nextIndex = index + (isRtl ? -1 : 1);
        if (event.key === 'ArrowLeft') nextIndex = index + (isRtl ? 1 : -1);
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === undefined) return;

        event.preventDefault();
        this.activate(nextIndex, { focus: true, scrollTab: true });
      }

      activate(nextIndex, options = {}) {
        const normalizedIndex = (nextIndex + this.tabs.length) % this.tabs.length;
        this.activeIndex = normalizedIndex;

        this.tabs.forEach((tab, index) => {
          const isActive = index === normalizedIndex;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        });

        this.panels.forEach((panel, index) => {
          const isActive = index === normalizedIndex;
          panel.hidden = !isActive;
          panel.classList.toggle('is-active', isActive);
        });

        const activeTab = this.tabs[normalizedIndex];
        if (options.focus) activeTab.focus({ preventScroll: true });
        if (options.scrollTab && activeTab.scrollIntoView) {
          activeTab.scrollIntoView({
            behavior: this.prefersReducedMotion.matches ? 'auto' : 'smooth',
            block: 'nearest',
            inline: 'center',
          });
        }
      }
    }

    customElements.define('lk-kloset-index', LKKlosetIndex);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
